export default "__VITE_ASSET__w$l56tEo__"